'use client';

import { createContext } from 'react';
import type { CheckoutProgressStepperContextValue } from './CheckoutProgressStepper.types';

export const CheckoutProgressStepperContext = createContext<CheckoutProgressStepperContextValue | null>(null);
